import React from 'react';
import keyBy from 'lodash-es/keyBy';

import { schema, useEnableSchema } from '@rover/components/src/microdata';
import SERVICES, {
  ServiceDescriptorType,
} from '@rover/constants/src/translations/services.constants';
import { Box, Text } from '@rover/kibble/core';
import Join from '@rover/react-lib/src/components/utils/Join';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';

type KeyBy<T extends any[], K extends string> = Record<T[number][K], T[number]>;

const OfferedServices: React.FC<{ slugs: ServiceTypeSlug[] }> = ({ slugs }) => {
  const enableSchema = useEnableSchema();

  const servicesByType: KeyBy<ServiceDescriptorType[], 'type'> = keyBy(SERVICES(), 'type');

  const offeredServices = slugs
    .map((slug) => servicesByType[slug]?.title)
    .filter(Boolean)
    .map((serviceName) => (
      <span
        key={serviceName}
        {...(enableSchema
          ? { itemProp: 'itemListElement', itemScope: true, itemType: schema`Service` }
          : {})}
      >
        <span {...(enableSchema ? { itemProp: 'name' } : {})}>{serviceName}</span>
      </span>
    ));

  return (
    <Box
      mb="2x"
      {...(enableSchema
        ? { itemProp: 'hasOfferCatalog', itemScope: true, itemType: schema`OfferCatalog` }
        : {})}
    >
      {enableSchema && <meta itemProp="numberOfItems" content={`${offeredServices.length}`} />}
      <Text size="100" fontWeight="semibold">
        <Join separator=", ">{offeredServices}</Join>
      </Text>
    </Box>
  );
};

export default OfferedServices;
